import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuthenticatedImage } from '../utils/imageUtils';

const AuthenticatedImage = ({ 
  imageId, 
  type = 'serve', 
  alt = 'Image',
  fallbackToServe = false,
  sx = {},
  ...props 
}) => {
  const { imageUrl, loading, error } = useAuthenticatedImage(imageId, type);
  const { imageUrl: fallbackUrl, loading: fallbackLoading } = useAuthenticatedImage(
    error && fallbackToServe ? imageId : null, 
    'serve'
  );

  if (loading || (fallbackToServe && fallbackLoading && error)) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          minHeight: 60,
          ...sx 
        }}
        {...props}
      >
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (error && !fallbackUrl) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: 'grey.100',
          color: 'grey.500',
          minHeight: 60,
          ...sx 
        }}
        {...props}
      >
        Image unavailable
      </Box>
    );
  }

  const srcUrl = fallbackUrl || imageUrl;

  return (
    <Box
      component="img"
      src={srcUrl}
      alt={alt}
      sx={sx}
      {...props}
    />
  );
};

export default React.memo(AuthenticatedImage);
